export const PAGE_HOME_PATH = '/';
export const PAGE_GAME_PATH = '/game';